export class Alert {
    type: AlertType;
    message: string;
}
 
export enum AlertType {
    Success,
    Error,
    Info,
    Warning
}


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/alert.ts